const UNITS = ["B", "KB", "MB", "GB"];

export default (bytes) => {
  if (bytes === null || bytes === undefined || isNaN(bytes)) return "-";
  let value = Number(bytes);
  let unit = 0;
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024;
    unit++;
  }
  return `${unit === 0 ? value : value.toFixed(2)} ${UNITS[unit]}`;
};



// WEBPACK FOOTER //
// ./src/filters/fileSize.js